import PropTypes from 'prop-types'

import TagChip, {atomTagSizes} from '@s-ui/react-atom-tag'

const BASE_CLASS = 'mt-HeroBasic'

const HeroBasicTag = ({tag}) => {
  const {label, size = atomTagSizes.LARGE, icon} = tag
  return (
    <div className={`${BASE_CLASS}-tag`}>
      <TagChip label={label} icon={icon} size={size} />
    </div>
  )
}

HeroBasicTag.propTypes = {
  tag: PropTypes.shape({
    label: PropTypes.string,
    icon: PropTypes.node,
    size: PropTypes.oneOf(Object.values(atomTagSizes))
  })
}

export {atomTagSizes as heroBasicTagSizes}

export default HeroBasicTag
